import { selectCurrentIDToken } from '../store/slices/auth/authSelectors';
import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';
import { RootState } from 'src/store/store';

interface ConvertedTaxableActivity {
  allowableDeductions: number;
  dateEnd: string;
  dateStart: string;
  numDaysAvailable: number;
  numDaysOccupied: number;
  provider: string | undefined;
  taxableReceipts: number | undefined;
  totalRevenue: number;
}

interface ConvertedPaymentPeriod {
  dateEnd: string;
  dateStart: string;
  license: string | undefined;
  misc: { taxableActivities: ConvertedTaxableActivity[] | undefined };
}

export interface CalculateMultiPropertyTotBody {
  mandatoryAcknowldgements: Record<string, { label: string }>;
  numPaymentPeriods: number;
  paymentId: string | null | undefined;
  paymentPeriods: ConvertedPaymentPeriod[];
}

export const calculateMultiPropertyTotAsync = async (
  state: RootState,
  body: CalculateMultiPropertyTotBody
) => {
  const accessToken = selectCurrentIDToken(state);
  return await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/calculateMultiPropertyTot`,
    body,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const downloadTaxSummary = async (
  paymentId: string,
  accessToken: string
): Promise<Blob> => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/downloadTaxPaymentSummary/${paymentId}`,
    {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data as Blob;
};
